import axios from "axios";
import { getUser, logOutUser, getLocalKey, setReturnURL } from '../utils/commonfunction';
import Swal from "sweetalert2";
import { ROLE, SWAL_SETTINGS } from "./Constants";

// Guard flag to prevent infinite 401 logout loops.
// Once logout is triggered, all subsequent 401s are silently ignored
// until the page fully redirects (module reloads on next page).
let isLoggingOut = false;

const Axios = (options = {}) => {
  // console.log(options , "page axios")
  const baseURL = process.env.REACT_APP_API_URL
  let headers = {
    language: getLocalKey('system_language') ? getLocalKey('system_language') : 'en'
  };

  try {
    let userData = options?.role ? getUser(options.role) : null;
    if (!userData || !userData.token) {
      userData = getUser(ROLE.USER);
    }
    if (!userData || !userData.token) {
      userData = getUser(ROLE.ADVERTISER);
    }
    if (!userData || !userData.token) {
      userData = getUser(ROLE.ADMIN);
    }

    if (userData && userData.token) {
      headers.Authorization = `Bearer ${userData.token}`;
    }
  } catch (err) {
    console.log(err);
  }

  const axiosInstance = axios.create({
    baseURL: `${baseURL}/webservice/api/v1`,
    headers
  });

  axiosInstance.interceptors.response.use((response) =>
    new Promise((resolve, reject) => {
      resolve(response.data);
    }), (error) => {
      console.error("error -----> ", error);
      if (error && error.response && error.response.status && error.response.status === 401) {
        // If already handling a 401 logout, silently drop all subsequent 401s
        // to stop the infinite API call loop while the page is redirecting.
        if (isLoggingOut) {
          return Promise.reject(error);
        }
        isLoggingOut = true;

        let actualRole = options?.role;
        if ((!getUser(options?.role) || !getUser(options?.role).token) && options?.role === ROLE.ADVERTISER) {
          if (getUser(ROLE.USER) && getUser(ROLE.USER).token) {
            actualRole = ROLE.USER;
          }
        }
        setReturnURL(actualRole);
        logOutUser(actualRole);
        Swal.fire({
          icon: "error",
          text: (error?.response?.data?.message) || "Session expired. Please log in again.",
          ...SWAL_SETTINGS,
        });
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default Axios;